"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var palette = _interopRequireWildcard(require("../../shared/oldDocumentSignerUI/palette"));

var _isFilledIn = _interopRequireDefault(require("../../utilities/isFilledIn"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HoC
// MaterialUI Components
var styles = function styles(theme) {
  return {
    primaryText: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      fontSize: 14
    },
    secondaryText: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: 11
    },
    complete: {
      marginRight: 0,
      color: palette.success2
    },
    incomplete: {
      marginRight: 0,
      color: palette.grey
    },
    error: {
      marginRight: 0,
      color: theme.palette.error.main
    }
  };
};

var DocumentSelectorField = function DocumentSelectorField(_ref) {
  var _ref$field = _ref.field,
      field = _ref$field === void 0 ? {} : _ref$field,
      goToField = _ref.goToField,
      classes = _ref.classes;
  var id = field.id,
      page = field.page,
      value = field.value,
      name = field.name,
      displayName = field.displayName,
      _field$_derived = field._derived,
      fieldType = _field$_derived.fieldType,
      error = _field$_derived.error;
  var isAck = fieldType === 'ACK';
  var fieldName = isAck ? 'Acknowledgment' : displayName || name;
  var isValueFilledIn = (0, _isFilledIn.default)(value);

  var statusText = function () {
    if (error) return error.message || 'Error';
    if (isValueFilledIn) return isAck ? 'Confirmed' : 'Validation Satisfied';
    return 'Incomplete';
  }();

  var caption = (page ? "Page ".concat(page, " - ") : '') + statusText;

  var icon = function () {
    if (error) return /*#__PURE__*/_react.default.createElement(_icons.ErrorOutline, {
      className: classes.error
    });
    if (isValueFilledIn) return /*#__PURE__*/_react.default.createElement(_icons.Check, {
      className: classes.complete
    });
    return /*#__PURE__*/_react.default.createElement(_icons.Close, {
      className: classes.incomplete
    });
  }();

  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    onClick: goToField,
    "data-test-id": "DocumentSelectorField-root-".concat(id)
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
    "data-test-id": "DocumentSelectorField-fieldStatusIcon-".concat(id)
  }, icon), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: fieldName,
    secondary: caption,
    classes: {
      primary: classes.primaryText,
      secondary: classes.secondaryText
    },
    "data-test-id": "DocumentSelectorField-fieldText-".concat(id)
  }));
};

var _default = (0, _styles.withStyles)(styles)(DocumentSelectorField);

exports.default = _default;